var _path, _path2, _path3, _path4, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuiserieexterieure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9147 46.8044H3.07061V3.96038H45.9147V46.8044Z",
    stroke: "#A3AED0",
    strokeWidth: 2.1422
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21265 44.6623V6.10266H43.7723V44.6623H5.21265Z",
    stroke: "#A3AED0",
    strokeWidth: 2.1422
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4924 6.10266V44.6623",
    stroke: "#A3AED0",
    strokeWidth: 3.99878
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4213 44.6623H6.28369L7.81059 40.5906C11.0633 31.9166 13.177 22.8574 14.0988 13.6396L14.8525 6.10266L15.1735 9.31254C16.3825 21.4029 19.1549 33.2853 23.4213 44.6623Z",
    stroke: "#A3AED0",
    strokeWidth: 2.17933
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.848,
    cy: 26.739,
    r: 1.85658,
    fill: "#A3AED0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuiserieexterieure);
export default __webpack_public_path__ + "static/media/Menuiserieexterieure.fb73aed37b9ddfcdacbe77a0e04447c6.svg";
export { ForwardRef as ReactComponent };